export function getScoreColor(score: number): string {
  if (score >= 80) return '#10b981'; // emerald-500
  if (score >= 60) return '#34d399'; // emerald-400
  if (score >= 40) return '#fbbf24'; // amber-400
  if (score >= 20) return '#f97316'; // orange-500
  return '#ef4444'; // red-500
}

export function getScoreLabel(score: number): string {
  if (score >= 80) return 'Excellent';
  if (score >= 60) return 'Good';
  if (score >= 40) return 'Average';
  if (score >= 20) return 'Below Average';
  return 'Poor';
}

export function getScoreBgClass(score: number): string {
  if (score >= 80) return 'bg-emerald-500/20 text-emerald-400';
  if (score >= 60) return 'bg-emerald-400/20 text-emerald-300';
  if (score >= 40) return 'bg-amber-400/20 text-amber-400';
  if (score >= 20) return 'bg-orange-500/20 text-orange-400';
  return 'bg-red-500/20 text-red-400';
}
